export const StorageKeys = {
    GridHistory: 'GridHistory',
    GridInteractions: 'GridInteractions',
    GridUsers: 'GridUsers',
}